import store from "../redux/store";
import { request } from "@/request";
import { apiConstants } from "@/utils/apiConstant";
import {
  allowedImagesType,
  appraisalStatus,
  inspectorImagesLabels,
  roles,
} from "@/utils/constant";
import * as actionTypes from "@/redux/page/types";
import { message } from "antd";
import { updateLocalStorage } from "@/utils/helpers";

const state = store.getState();
const user = state?.auth?.current?.user;

export const getCarMakesList = async () => {
  try {
    const entity = apiConstants.CAR_MAKE_ENDPOINT;
    const response = await request.get(entity, false);

    return response?.result
      ? {
        data: response?.result.map((item) => ({
          label: item.make,
          value: item.make,
          id: item._id,
        })),
        success: true,
      }
      : {
        data: null,
        success: false,
      };
  } catch (error) {
    console.log("Error fetching car makes:", error);
  }
};

export const getAllCarModels = async (id) => {
  try {
    const entity = `${apiConstants.CAR_MODELS_ENDPOINT}/${id}`;
    const response = await request.get(entity, false);

    return response?.result
      ? {
        data: response?.result?.models.map((item) => ({
          label: item.model,
          value: item.model,
        })),
        success: true,
      }
      : {
        data: null,
        success: false,
      };
  } catch (error) {
    console.log("Error fetching car models:", error);
  }
};

export const getAllModelsService = async () => {
  try {
    const entity = `${apiConstants.CAR_MODELS_ENDPOINT}`;
    const response = await request.get(entity, false);

    return response?.result
      ? {
        data: response?.result?.allModels.map((item) => ({
          label: item.title,
          value: item.model,
        })),
        success: true,
      }
      : {
        data: null,
        success: false,
      };
  } catch (error) {
    console.log("Error fetching car models:", error);
  }
};

export const onFinish = async (
  values,
  inspectionData,
  state,
  navigate,
  dispatch,
  actionTypes,
  shopProfile,
  deletedFiles
) => {
  try {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    let formData = {
      insured: { ...values },
      photos: inspectionData?.images,
      deletedFiles,
    };

    // dispatch({
    //   type: actionTypes.LOADING_FALSE,
    // });

    for (const photo of formData?.photos || []) {
      if (
        photo?.image instanceof File &&
        !allowedImagesType?.includes(photo?.image?.type)
      ) {
        message.error(
          `Invalid Photo Type of ${inspectorImagesLabels[photo?.key]}`
        );
        dispatch({
          type: actionTypes.LOADING_FALSE,
        });
        return false;
      }
    }

    if (state?.isEdit || state?.isReuploadPage) {
      formData.updatedBy = user?.id;
    } else {
      formData.createdBy = user?.id;
    }

    const data = new FormData();
    if (formData?.insured.claimNumber === "") {
      let _insured = { ...formData.insured };
      _insured.claimNumber = null;
      formData.insured = _insured;
    }

    data.append("insured", JSON.stringify(formData?.insured));

    if (!state?.isEdit && !state?.isReuploadPage) {
      data.append("createdBy", formData?.createdBy);
    } else {
      data.append("updatedBy", formData?.updatedBy);
    }

    if (state?.isReuploadPage) {
      data.append("status", appraisalStatus?.IN_PROGRESS);
      data.append("isObjection", false);
      data.append("isReupload", true);
    }

    data.append("assignedTo", shopProfile?.appraisalWriter?._id);

    data.append("assignedShop", shopProfile?._id);

    data.append("deletedFiles", JSON.stringify(formData?.deletedFiles));
    let _photos = formData?.photos.filter((item) => item.image !== "");
    data.append("photos", JSON.stringify(_photos));


    // if (formData?.photos && formData?.photos?.length > 0) {
    //   formData?.photos?.forEach((photo) => {
    //     // if (photo?.image instanceof File) {
    //     data.append("photoKeys", photo?.key);
    //     data.append("photos", photo?.image); // Use the same key as expected by the API
    //     // }
    //   });
    // }

    let response;
    if (state?.isEdit || state?.isReuploadPage) {
      response = await request.put(
        `${apiConstants?.POST_OR_PUT_APPRAISALS}/${state?.id}`,
        data
      );
    } else {
      response = await request.post(
        `${apiConstants?.POST_OR_PUT_APPRAISALS}`,
        data
      );
    }

    dispatch({
      type: actionTypes.CURRENT_PAGE_SUCCESS,
      payload: {
        shopFormData: response,
      },
    });

    if (!state?.isEdit && !state?.isReuploadPage) {
      dispatch({
        type: actionTypes.NEW_APPRAISAL,
      });
    }
    if (response?.result) {
      navigate(-1);
      dispatch({ type: actionTypes.LOADING_FALSE });
    }
    dispatch({ type: actionTypes.LOADING_FALSE });

    return response?.result;
  } catch (error) {
    console.log(
      `${state?.isEdit || state?.isReuploadPage
        ? "Error updating appraisal request:"
        : "Error Submiting appraisal request:"
      } `,
      error
    );
  }
};

export const getAppraisalById = async (id) => {
  try {
    const entity = `${apiConstants.GET_APPRAISAL_BY_ID}/${id}`;
    const response = await request.get(entity, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching appraisal by Id:", error);
  }
};

export const updateShopStatus = async (
  appraisalId,
  status,
  notes,
  values,
  state,
  infoFile = null,
  fileKeys
) => {
  try {
    const comment = values?.issuesExplanation || notes;
    const issueTag = values?.photoQuality;

    const files = values?.photoFeedbacks?.map((item) => ({
      key: item?.key,
      fileUrl: item?.image,
      comment: item?.feedback,
      type: "image",
    }));

    const issueType = values?.photosFeedbackIssues?.filter(
      (item) => item?.radio === values?.photoQuality
    );

    const issueList =
      issueType?.length > 0
        ? issueType[0]?.issues
          ?.filter((item) => item?.checked)
          .map((item) => item?.label)
        : [];

    let chatBody = {
      status,
      updatedBy: user?.id,
      attachments: files,
      issues: {
        issueTag,
        issueList,
      },
      isFeedback: values?.isFeedback,
      isObjection: values?.isObjection,
      userComment: comment,
    };
    if (!state?.isphotoUpdate) {
      chatBody = {
        isFeedback: values?.isFeedback,
        userComment: comment,
        amount: values?.amount || 0,
        requiredAction: values?.requiredAction,
        actionDateTime: values?.actionDateTime,
      };
    }

    const data = {
      status,
      notes,
      updatedBy: user?.id,
      chatBody,
      isObjection: values?.isObjection || false,
      isFeedback: values?.isFeedback || false,
      estimatedAmount: values?.estimatedAmount,
      suggestedAmount: values?.suggestedAmount,
      approvedAmount: values?.approvedAmount,
      insuranceUploadedAmount: values?.insuranceUploadedAmount,
      insuranceAmount: values?.insuranceAmount,
      attachments: infoFile,
      fileKeys,
    };

    const formData = new FormData();

    if (infoFile) {
      Object.keys(data).forEach((key) => {
        if (data[key] !== undefined) {
          formData.append(
            key,
            key === "chatBody" ? JSON.stringify(data[key]) : data[key]
          );
        }
      });
    }

    const entity = `${apiConstants.PUT_SHOP_STATUS}/${appraisalId}`;
    const response = await request.put(entity, infoFile ? formData : data);
    return response?.result
      ? {
        data: response?.result,
        success: true,
      }
      : { data: null, success: false };
  } catch (error) {
    console.log("Error updating shop status:", error);
  }
};

export const getChatByAppraisalId = async (id, page) => {
  try {
    const entity = `${apiConstants.GET_CHAT_BY_APPRAISAL_ID}/${id}?page=${page}&sortOrder=desc`;
    const response = await request.get(entity, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching chats by appraisal Id:", error);
  }
};

export const updateNotifyFromRow = async (id, notifyObj) => {
  try {
    const notify = {
      role: notifyObj?.role,
      isNotify: false,
    };
    const entity = `${apiConstants.UPDATE_NOTIFY}/${id}`;
    const response = await request.put(entity, notify);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error updating notify from rows:", error);
  }
};

export const getAppraisalListing = async ({
  pageNo,
  pageSize,
  overDue,
  status,
  startDate,
  endDate,
  writerId,
  pagination,
  claimOrVinNum,
  model,
  payType,
  sortField,
  sortOrder,
  customer,
}) => {
  try {
    const params = {
      page: pageNo || 1,
      pageSize: pageSize || 10,
      status: status || "",
      overDue,
      startDate,
      endDate,
      writerId,
      pagination,
      claimOrVinNum,
      model,
      payType,
      sortField,
      sortOrder,
      customer,
    };
    const response = await request.get(
      apiConstants.GET_APPRAISALS,
      false,
      params
    );
    return {
      ...response,
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching listing by appraisal:", error);
  }
};

export const sendMessage = async (
  appraisalId,
  appraisalStatus,
  updatedBy,
  userComment,
  attachments
) => {
  try {
    const data = new FormData();
    data.append("appraisalId", appraisalId);
    data.append("appraisalStatus", appraisalStatus);
    data.append("updatedBy", updatedBy);
    data.append("userComment", userComment);
    data.append("isFeedback", false);
    data.append("isObjection", false);
    attachments.forEach((file) => {
      data.append("attachments", file);
      data.append("fileKeys", file.name + Math.random() * 10);
    });

    const response = await request.post(
      `${apiConstants.POST_CHAT_MESSAGES}/${appraisalId}`,
      data,
      false
    );
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error sending message in chats:", error);
  }
};

export const updateChat = async (_id, body) => {
  try {
    const entity = `${apiConstants.UPDATE_CHAT}/${_id}`;
    const response = await request.put(entity, body, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error updating chat:", error);
  }
};

export const fetchCapabilities = async () => {
  try {
    const entity = apiConstants.FETCH_ALL_CAPABILITIES;
    const response = await request.get(entity, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching capabilites:", error);
  }
};

export const fetchAllRoleUsers = async (param, shopId) => {
  try {
    const entity = apiConstants.GET_ALL_ROLE_USERS;
    const response = await request.get(
      `${entity}?name=${param}&shopId=${shopId}`,
      false
    );
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching role users:", error);
  }
};

export const createShop = async (values, image, navigate, dispatch) => {
  try {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const formData = { ...values, file: image?.file };

    const data = new FormData();
    data.append("shopName", formData?.shopName);
    formData?.pocName?.forEach((item) => {
      data.append("poc", item);
    });
    data.append("location", formData?.location);
    data.append("additionalCapabilities", formData?.additionalCapabilities);
    data.append("preferredUsedPartVendors", formData?.vendorsList);
    data.append("approvalBeforeUploadingEstimates", formData?.autoApproval);
    data.append("appraisalWriter", formData?.writer?.value);
    data.append("createdBy", user?.id);
    data.append("photos", formData?.file);
    data.append("photoKeys", "shopLogo");
    formData?.checkboxes.forEach((item) => {
      data.append("capabilities", item);
    });

    const entity = apiConstants.CREATE_SHOP;
    const response = await request.post(entity, data);

    dispatch({
      type: actionTypes.REQUEST_SUCCESS,
    });
    navigate(-1);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error creating shop:", error);
  }
};

export const editShop = async (
  _id,
  values,
  image,
  deletedFiles,
  navigate,
  dispatch
) => {
  try {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const formData = { ...values, file: image?.file };

    const data = new FormData();
    data.append("shopName", formData?.shopName);
    formData?.pocName?.forEach((item) => {
      data.append("poc", item);
    });
    data.append("location", formData?.location);
    data.append("additionalCapabilities", formData?.additionalCapabilities);
    data.append("preferredUsedPartVendors", formData?.vendorsList);
    data.append("approvalBeforeUploadingEstimates", formData?.autoApproval);
    data.append("appraisalWriter", formData?.writer?.value);
    data.append("isActive", formData?.isActive);
    data.append("createdBy", user?.id);
    data.append("deletedFiles", JSON.stringify(deletedFiles));
    if (image?.file) {
      data.append("photos", formData?.file);
      data.append("photoKeys", "shopLogo");
    }
    formData?.checkboxes.forEach((item) => {
      data.append("capabilities", item);
    });

    const entity = apiConstants.EDIT_SHOP;
    const response = await request.put(`${entity}/${_id}`, data);

    dispatch({
      type: actionTypes.REQUEST_SUCCESS,
    });

    navigate(-1);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error updating shop:", error);
  }
};

export const editShopToActiveOrInactive = async (_id, data) => {
  try {
    const entity = apiConstants.EDIT_SHOP;
    const response = await request.put(`${entity}/${_id}`, data, false);

    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error updating shop:", error);
  }
};

export const fetchAllShops = async ({
  pageNo,
  pageSize,
  status,
  pagination = true,
  isActive = true,
}) => {
  try {
    const params = {
      page: pageNo || 1,
      pageSize: pageSize || 10,
      status: status || "",
      pagination: pagination,
      isActive: isActive,
    };
    const entity = apiConstants.GET_ALL_SHOPS;
    const response = await request.get(`${entity}`, false, params);
    return {
      ...response,
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching shops:", error);
  }
};

export const fetchAllStaff = async (
  { pageNo, pageSize, status, pagination = true, isActive, shopAssigned },
  role
) => {
  try {
    const params = {
      page: pageNo || 1,
      pageSize: pageSize || 10,
      status: status || "",
      pagination: pagination,
      isActive: isActive,
      shopAssigned
    };
    let entity;
    if (role) {
      entity = `${apiConstants.GET_ALL_STAFF}?role=${role}`;
    } else {
      entity = apiConstants.GET_ALL_STAFF;
    }
    const response = await request.get(`${entity}`, false, params);
    return {
      ...response,
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching staff:", error);
  }
};

export const getShopById = async (id) => {
  try {
    const entity = `${apiConstants.GET_SHOP_BY_ID}/${id}`;
    const response = await request.get(entity, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching shop by Id:", error);
  }
};

export const deleteShopById = async (_id) => {
  try {
    const entity = `${apiConstants.DELETE_SHOP}/${_id}`;
    const jsonData = { isActive: false };

    const response = await request.put(entity, jsonData, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error deleting shop by Id:", error);
  }
};

export const getStaffById = async (id) => {
  try {
    const entity = `${apiConstants.GET_STAFF_BY_ID}/${id}`;
    const response = await request.get(entity, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching staff by Id:", error);
  }
};

export const deleteStaffById = async (_id) => {
  try {
    const entity = `${apiConstants.DELETE_SHOP}/${_id}`;
    const jsonData = { isActive: false };

    const response = await request.put(entity, jsonData, true);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error deleting shop by Id:", error);
  }
};

export const fetchAllRoles = async ({ pageNo, pageSize }) => {
  try {
    const params = {
      page: pageNo || 1,
      pageSize: pageSize || 10,
    };
    const entity = apiConstants.FETCH_ALL_ROLES;
    const response = await request.get(`${entity}`, false, params);
    return {
      ...response,
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching roles:", error);
  }
};

export const getRoleById = async (id) => {
  try {
    const entity = `${apiConstants.GET_ROLE_BY_ID}/${id}`;
    const response = await request.get(entity, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching shop by Id:", error);
  }
};

export const updateRolePermissions = async (roleId, updateData) => {
  try {
    const entity = `${apiConstants.UPDATE_ROLE_PERMISSIONS}/${roleId}`;
    const response = await request.put(entity, updateData, true);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error updating shop status:", error);
  }
};

export const userEdit = async (
  state,
  values,
  image,
  deletedFiles,
  navigate,
  dispatch
) => {
  try {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const formData = { ...values, file: image?.file, deletedFiles };

    const data = new FormData();

    data.append("name", formData?.name);
    data.append("phone", formData?.phone);
    data.append("isActive", true);
    data.append("deletedFiles", JSON?.stringify(deletedFiles));

    if (image?.file) {
      data.append("photos", formData?.file);
      data.append("photoKeys", "profileImage");
    }

    const entityURL = apiConstants.EDIT_USER;
    const response = await request.put(`${entityURL}/${state?.id}`, data);

    dispatch({
      type: actionTypes.REQUEST_SUCCESS,
    });

    const _localStorage = { ...JSON.parse(localStorage.getItem("auth")) };
    let _current = { ..._localStorage?.current };
    let _user = { ..._current?.user };

    if (_user?.role !== roles.ADMIN) {
      updateLocalStorage(response?.result);
    }
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error updating user:", error);
  }
};

export const getAppraisalWorkload = async (params) => {
  try {
    const entity = `${apiConstants.GET_APPRAISAL_WORKFLOW}`;
    const response = await request.get(entity, false, params);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching appraisal workload:", error);
  }
};

export const getWriterQualityDataListing = async ({
  pageNo,
  pageSize,
  status,
  startDate,
  endDate,
  writerId,
  shopId,
  pagination,
}) => {
  try {
    const params = {
      page: pageNo || 1,
      pageSize: pageSize || 10,
      status: status || "",
      startDate,
      endDate,
      assignedTo: writerId,
      shopId,
      pagination,
    };
    const response = await request.get(
      apiConstants.GET_WRITER_QUALITY,
      false,
      params
    );
    return {
      ...response,
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching listing by appraisal:", error);
  }
};

export const getWriterWorkload = async (params) => {
  try {
    const entity = `${apiConstants.GET_WRITER_WORKLOAD}`;
    const response = await request.get(entity, false, params);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching writer workload:", error);
  }
};

export const updateAppraisalAssignTo = async (_id, body) => {
  try {
    const entity = `${apiConstants.UPDATE_WRITER_ON_APPRAISAL}/${_id}`;
    const response = await request.put(
      entity,
      { ...body, updatedBy: user?.id },
      true
    );
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error updating Writer:", error);
  }
};

export const bulkUpdateAppraisalAssignTo = async (body) => {
  try {
    const entity = `${apiConstants.BULK_UPDATE_APPRAISALS_ON_WRITER}`;
    const response = await request.post(
      entity,
      { ...body, updatedBy: user?.id },
      true
    );
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error bulk updating Writer:", error);
  }
};

export const createNewInsuranceCompany = async (data) => {
  try {
    const entity = `${apiConstants.CREATE_INSURANCE_COMPANY}`;

    const formData = new FormData();
    formData.append("insuranceName", data?.insuranceName);
    formData.append("attachments", data?.attachments);
    formData.append("fileKeys", "guidelines");

    const response = await request.post(entity, formData, true);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error creating insurance company:", error);
  }
};

export const getAllInsuranceListing = async ({
  pageNo,
  pageSize,
  pagination,
}) => {
  try {
    const params = {
      page: pageNo || 1,
      pageSize: pageSize || 10,
      pagination: pagination,
    };
    const entity = `${apiConstants.GET_ALL_INSURANCE_COMPANY}`;
    const response = await request.get(entity, false, params);
    return {
      ...response,
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching insurance company:", error);
  }
};

export const getInsuranceCompanyById = async (_id) => {
  try {
    const entity = `${apiConstants.GET_INSURANCE_COMPANY_BY_ID}`;
    const response = await request.get(`${entity}/${_id}`, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error creating insurance company:", error);
  }
};

export const deleteInsuranceById = async (_id) => {
  try {
    const entity = `${apiConstants.DELETE_INSURANCE_COMPANY_BY_ID}/${_id}`;
    const jsonData = { isDeleted: true };

    const response = await request.put(entity, jsonData, true);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error deleting shop by Id:", error);
  }
};

export const editInsuranceCompany = async (_id, data) => {
  try {
    const entity = apiConstants.UPDATE_INSURANCE_COMPANY_BY_ID;
    const formData = new FormData();
    formData.append("insuranceName", data?.insuranceName);
    formData.append("attachments", data?.attachments);
    formData.append("fileKeys", "guidelines");

    const response = await request.put(`${entity}/${_id}`, formData);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error updating Insurance :", error);
  }
};

export const fetchSlaConfigService = async () => {
  try {
    const entity = apiConstants.GET_SLA_CONFIG;
    const response = await request.get(
      `${entity}/${process.env.REACT_APP_CLEANSHEET_SLA_DOCUMENT_ID}`,
      false
    );
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching SLA Config :", error);
  }
};

export const updateSlaConfigService = async (slaConfig) => {
  try {
    const entity = apiConstants.UPDATE_SLA_CONFIG;
    const response = await request.put(
      `${entity}/${process.env.REACT_APP_CLEANSHEET_SLA_DOCUMENT_ID}`,
      slaConfig
    );
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error updating SLA Config :", error);
  }
};

export const getOverdueDataService = async () => {
  try {
    const entity = `${apiConstants.GET_OVERDUE_DATA}`;
    const response = await request.get(entity, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error Fetching Overdue Data:", error);
  }
};

export const updateRating = async (data, _id) => {
  try {
    const entity = apiConstants?.POST_OR_PUT_APPRAISALS;
    const response = await request.put(`${entity}/${_id}`, data, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error While Updating Rating:", error);
  }
};

export const getRateListingForShopsService = async (param) => {
  try {
    const entity = apiConstants?.RATING_LIST_DATA;
    const response = await request.get(entity, false, param);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error Fetching Rating List:", error);
  }
};

export const getRateListingWritersService = async (param) => {
  try {
    const entity = apiConstants?.RATING_LIST_WRITERS;
    const response = await request.get(entity, false, param);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error Fetching Writer List:", error);
  }
};

export const VerifyTokenService = async (token) => {
  try {
    const entity = `${apiConstants?.VERIFY_TOKEN}/${token}`;
    const response = await request.patch(entity, {}, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error while verifying token:", error);
  }
};

export const resendEmail = async (_id) => {
  try {
    const entity = `${apiConstants?.RESEND_ONBOADRING_EMAIL}/${_id}`;
    const response = await request.post(entity);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error while verifying token:", error);
  }
};

export const updateUsers = async ({ id, name, phone, isActive }) => {
  try {
    const data = new FormData();

    data.append("name", name);
    data.append("phone", phone);
    data.append("isActive", isActive);

    const entityURL = apiConstants.EDIT_USER;
    const response = await request.put(`${entityURL}/${id}`, data);

    const _localStorage = { ...JSON.parse(localStorage.getItem("auth")) };
    let _current = { ..._localStorage?.current };
    let _user = { ..._current?.user };

    if (_user?.role !== roles.ADMIN) {
      updateLocalStorage(response?.result);
    }
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error updating user:", error);
  }
};

export const handleFileUploadDelete = async ({ uploadFile, deleteFile, tempImage }) => {
  try {
    const data = new FormData();
    data.append("photos", uploadFile.image);
    data.append("photoKeys", uploadFile.key);
    data.append("tempImage", tempImage);

    const entityURL = apiConstants.UPLOAD_DELETE_IMAGE + "?tempImage=true";
    const response = await request.post(`${entityURL}`, data);

    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error handling file:", error);

  }
}